import { defineMessages } from "react-intl";

const DATA_REPORTS = "data-reports";

const dataReportsMessages = defineMessages({
  yourReportsAvailable: {
    id: `${DATA_REPORTS}.your-reports-available`,
    defaultMessage: "Your reports - available for 7 days",
    description: "Header text for reports"
  },
  requestNewReport: {
    id: `${DATA_REPORTS}.request-new-report`,
    defaultMessage: "Request new report",
    description: "Label for button to request a new report"
  },
  newReportSuccess: {
    id: `${DATA_REPORTS}.new-report-success`,
    defaultMessage: "Your request has been submitted.",
    description:
      "Toast notification text for when a data report request has been successfully submitted"
  }
});

export default dataReportsMessages;
